<template>
  <div>
    <wait-spinner v-if="loading" />
    <scorer-table-mimir v-if="gameType === 'mimir' && !loading" />
    <scorer-table-new v-if="gameType === 'stakes' && !loading" />

    <div v-if="!loading">
      <div v-if="freeDirect">Game was played <b>with</b> free directs. Boo!</div>
      <div v-else>Game was played <b>without</b> free directs exactly the way a mimir ought to be played.</div>
    </div>

    <div class="game-notes-container" v-if="!loading && gameNotes.length > 0">
      <h3 class="message-title">GAME NOTES:</h3>
      <!-- <p class="game-notes">
        {{ gameNotes }}
      </p> -->
      <textarea class="game-notes" id="" disabled :value="gameNotes" rows="5"></textarea>
    </div>

    <div v-if="!loading" class="copy-message-container">
      <span class="message-title">URL for sharing (click to copy):</span>
      <div class="copy-container">
        <span class="copy-message" @click="copyUrl()">
          {{ getShareMessageThis }}
        </span>
      </div>
      <span class="message-title">Wikiquiz equivalent URL:</span>
      <div class="copy-container" v-if="gameType === 'mimir'">
        <span class="copy-message wiki-url">
          {{ getWikiQuizUrl }}
        </span>
      </div>
    </div>
    <div v-if="gameType === 'mimir' && !loading && false">
      <extra-stats-table-vue />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

import ScorerTableMimir from "@/components/ScorerTableMimir.vue";
import ScorerTableNew from "@/components/ScorerTableNew.vue";
import WaitSpinner from "@/components/WaitSpinner.vue";
import ExtraStatsTableVue from "@/components/ExtraStatsTable.vue";

export default {
  name: "ResultView",
  components: {
    ScorerTableMimir,
    ScorerTableNew,
    WaitSpinner,
    ExtraStatsTableVue,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState([
      "gameType",
      "readerName",
      "numPlayers",
      "players",
      "numRounds",
      "numDirects",
      "gameStartTime",
      "gamePlayString",
      "resumeGame",
      "gameNotes",
      "freeDirect",
    ]),
    ...mapGetters(["getWikiQuizUrl"]),
    getUrl() {
      return `https://mimir-quiz-scorer.netlify.app${this.$route.fullPath}`;
    },
    getShareMessageThis() {
      return this.getUrl;
    },
  },
  methods: {
    ...mapActions(["fetchResultData"]),
    copyUrl() {
      navigator.clipboard.writeText(window.location.href).then(() => {
        this.$toast.open("URL copied to clipboard!", {
          type: "success",
          duration: 1000,
        });
      }).catch((error) => {
        console.error("Failed to copy URL: ", error);
        this.$toast.open("Failed to copy URL", {
          type: "error",
          duration: 1000,
        });
      });
    }
  },
  mounted() {
    this.loading = true;
    this.fetchResultData(this.$route.params.gameId).then(() => {
      this.loading = false;
    });
  },
};
</script>

<style scoped>
.copy-message-container {
  margin: 30px auto;
}

.message-title {
  font-size: 2vmin;
  margin: 20px auto;
  font-weight: bold;
}

h3.message-title {
  margin: 20px auto 0;
}

.copy-container {
  display: flex;
  justify-content: center;
}

.copy-message {
  font-size: 1.5vmin;
  padding: 1vmin;
  border: 0.5px solid gray;
  background-color: #eeeeee;
  border-radius: 5px;
  cursor: pointer;
}

.copy-message:hover {
  opacity: 60%;
}

.wiki-url {
  width: 80%;
  overflow-wrap: break-word;
}

.game-notes {
  border: 1px solid black;
  border-radius: 10px;
  padding: 15px;
  background-color: #e9e9e4;
  width: 70%;
  margin: 0 auto;
  font-size: 1.8vmin;
  resize: none;
}

.copy-icon {
  cursor: pointer;
  color: #555;
  font-size: 2.5vmin;
  border: 0.5px solid gray;
  background-color: #bbbbbb;
  padding: 1vmin 2vmin;
  border-radius: 2px;
}

.button-6 {
  align-items: center;
  background-color: #cccccc;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
  box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
  box-sizing: border-box;
  color: #9b9b9b;
  cursor: pointer;
  font-family: Nunito, Arial, Helvetica, sans-serif;
  font-size: 24px;
  justify-content: center;
  line-height: 24px;
  min-height: 3rem;
  padding: calc(0.875rem - 1px) calc(1.5rem - 1px);
  position: relative;
  text-decoration: none;
  transition: all 250ms;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: baseline;
}

.button-6:hover:not([disabled]),
.button-6:focus:not([disabled]) {
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
  color: rgba(0, 0, 0, 0.65);
}

.button-6:hover:not([disabled]) {
  transform: translateY(-1px);
}

.button-6:active {
  background-color: #f0f0f1;
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
  color: rgba(0, 0, 0, 0.65);
  transform: translateY(0);
}

.button-6:disabled {
  background-color: #eeeeee;
  color: #888888;
}
</style>
